"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var textTooltipStyles = makeStyles_1.default(function (theme) { return ({
    tooltipArrow: {
        color: theme.palette.primary.main,
        fontSize: theme.typography.fontXS,
    },
    tooltip: {
        border: '1.5px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: '10px',
        background: theme.palette.common.white,
        padding: theme.spacing(1.5),
        color: theme.palette.common.black,
        fontSize: theme.typography.fontXS,
    },
}); }, { name: 'Summary_Text_Tooltip' });
exports.default = textTooltipStyles;
